export enum OrderType {
    Default = 0,
    Deliver = 1,
    Pickup = 2,
    Takeaway = 3
}
